<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >

    <transition
      appear
      name="fadeside"
      mode="out-in"
    >
      <div
        v-if="step == 1"
        key="images"
      >
        <div class="tile is-ancestor">
          <div class="tile is-12 is-vertical">
            <div class="tile is-parent is-unselectable">
              <article class="tile is-parent is-12 is-paddingless has-text-left">
                <h3 class="clear-margin">{{$t("select_payment_method").tUpper()}}</h3>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child">
                <div class="columns is-multiline pmethods">
                  <div
                    class="column is-3"
                    v-if="checkPSP(img, name)"
                    v-for="(img, name) in paymentImages"
                    @click="selectMethod(name)"
                    :key="name"
                  >
                    <div class="box">
                      <img
                        v-if="name==='bankwire' && Language=='it'"
                        :src="img.pathIT"
                      />
                      <img
                        v-else
                        :src="img.path"
                      />
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tile is-ancestor form-container"
        v-if="step == 2"
        key="component"
      >
        <div class="tile is-12 is-parent">
          <div
            class="tile is-11 is-parent"
            v-if="selected.paymentMethod == name"
            v-for="(img, name) in paymentImages"
            :key="name"
          >
            <div class="tile is-3">
              <figure class="image is-100x100">
                <img
                  v-if="name==='bankwire' && Language=='it'"
                  :src="img.pathIT"
                />
                <img
                  v-else
                  :src="img.path"
                />
              </figure>
            </div>

            <div class="tile is-9">
              <div>
                <span
                  class="title"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar','has-text-left': Language != 'fa' && Language != 'ar'}"
                >{{$t(img.T)}}</span>

                <article class="tile is-child psp">
                  <component
                    :selected="selected"
                    v-bind:is="paymentImages[selected.paymentMethod].Component"
                    :apm="img.Component != name ? name : null"
                  ></component>
                </article>
              </div>
            </div>
          </div>

          <div class="tile is-1">
            <div class="topNav">
              <a
                class="button"
                @click="step--, selected.paymentMethod = ''"
              >
                <span class="icon is-small">
                  <i
                    class="fa fa-chevron-circle-left"
                    :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
                  ></i>
                </span>
                <span>{{$t("back")}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <error-modal></error-modal>
  </div>
</template>

<script>
// import RegularPay from './withdraw-methods/RegularPay'
// import EpayPro from './withdraw-methods/EpayPro'
// import EData from './withdraw-methods/EData'
import Skrill from './withdraw-methods/Skrill'
import Neteller from './withdraw-methods/Neteller'
import Bitcoin from './withdraw-methods/Bitcoin'
import Lydiax from './withdraw-methods/Lydiax'
// import KoalaPay from './withdraw-methods/KoalaPay'
// import PagoCUP from './withdraw-methods/PagoCUP'
// import Fasapay from './withdraw-methods/Fasapay'
import BankWire from './withdraw-methods/BankWire'
// import VLoad from './withdraw-methods/VLoad'
import SafeCharge from './withdraw-methods/SafeCharge'
import PowerCash from './withdraw-methods/PowerCash'
import Payneteasy from './withdraw-methods/Payneteasy'
import Mulix from './withdraw-methods/Mulix'
import { service } from '../../app'
import { mapGetters, mapActions } from 'vuex'
import api from '../../api'
import config from '../../config'
import ErrorModal from '../../components/ErrorModal'

const imgPath = require.context('../../assets/img/funding', true)

export default {
  components: {
    // RegularPay,
    // EpayPro,
    // EData,
    Skrill,
    Neteller,
    Bitcoin,
    // KoalaPay,
    // PagoCUP,
    // Fasapay,
    BankWire,
    // VLoad,
    Lydiax,
    SafeCharge,
    PowerCash,
    ErrorModal,
    Payneteasy,
    Mulix,
  },
  data() {
    return {
      step: 1,
      selected: {
        paymentMethod: '',
        amount: 0,
      },
      paymentImages: {},
      currencySymbols: config.currencies,
    }
  },
  watch: {
    'selected.paymentMethod'() {
      if (this.selected.paymentMethod) {
        this.step = 2
      }
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      Finance: 'finance/all',
    }),
  },
  created() {},
  mounted() {
    // PSPs (handling image loading/path)
    this.paymentImages = Object.assign({}, this.Finance.PSPs)

    // remove payneteasy until problem is solved
    // delete this.paymentImages.payneteasy

    let platNames = Object.keys(this.paymentImages)
    for (let i = 0, l = platNames.length; i < l; i++) {
      this.paymentImages[platNames[i]]['path'] = imgPath('./' + platNames[i] + '.svg', true)
      if (platNames[i] === 'bankwire') {
        this.paymentImages[platNames[i]]['pathIT'] = imgPath('./' + platNames[i] + '-it.svg', true)
      }
    }
    api.GetWallet()

    this.$bus.$on('RequestWithdraw', this.requestWithdraw)
  },
  beforeDestroy() {
    this.$bus.$off('RequestWithdraw', this.requestWithdraw)
  },
  methods: {
    selectMethod(method) {
      // if (method === 'bank-wire') {
      // 	this.$toasted.info('The bank wire transfer option is temporarily unavailable. Please select another withdrawal method until a new payment service provider is made available for sending and receiving bank wires. We will make all efforts to offer you an alternative bank wire transfer solution as soon as possible. We apologize for the inconvenience and greatly appreciate your patience and understanding.', { duration: 100000 })
      // 	return
      // }

      // if (method === 'bitcoin') {
      // this.$toasted.info('Due to some technical updates, this method is temporarily unavailable. Please use Crypto option to place your withdrawal by Bitcoin', { duration: 100000 })
      // return
      // }

      this['logoLoader/set'](true)
      service
        .post('finance/withdraw/check-method', {
          userID: this.User.info.ID,
          psp: this.paymentImages[method].Component,
        })
        .then(response => {
          this['logoLoader/set'](false)
          if (!response.data.Applicable) {
            if (typeof response.data.NeedsCreditCardAmount !== 'undefined') {
              if (response.data.NeedsCreditCardAmount > 0) {
                if (this.paymentImages[method].Component === 'regular-pay') {
                  this.selected.amount = response.data.NeedsCreditCardAmount
                } else {
                  this.$toasted.error(
                    this.$t('withdrawals_credit_card_remaining_amount_message', { amount: this.currencySymbols[this.User.wallet.currency] + response.data.NeedsCreditCardAmount }) +
                      '<span class="error-id"></span>',
                    {
                      duration: 20000,
                      action: {
                        text: 'Close',
                        onClick: (e, toastObj) => {
                          toastObj.goAway(0)
                        },
                      },
                    }
                  )
                  return
                }
              }
            } else if (typeof response.data.CountryIsBlocked !== 'undefined') {
              if (response.data.CountryIsBlocked) {
                this.$toasted.error(this.$t('country_blocked_for_this_method') + '<span class="error-id"></span>', { duration: 10000 })
              }
              return
            }
          }

          if (this.selected.paymentMethod === method) {
            return
          }
          this.selected.paymentMethod = method
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    checkPSP(img, name) {
      if (!this.User.wallet.currency) {
        return false
      }
      if (!img.BlockedCurrencies && !img.BlockedCountries) {
        return true
      }

      let PSPCurrencyAllowed = !img.BlockedCurrencies || !img.BlockedCurrencies.length || img.BlockedCurrencies.indexOf(this.User.wallet.currency.toUpperCase()) === -1
      let PSPCountryAllowed = !img.BlockedCountries || !img.BlockedCountries.length || img.BlockedCountries.indexOf(this.User.info.country_code.toUpperCase()) === -1

      if (img.Component == 'mulix') {
        let visatesters = [1, 48739, 39775, 45772]
        if (name == 'mulix-payretailers') {
          return PSPCurrencyAllowed && PSPCountryAllowed
        } else if (visatesters.includes(this.User.info.ID)) {
          return PSPCurrencyAllowed && PSPCountryAllowed
        } else {
          return false
        }
      }

      // temporarily removed visa withdrawals of US due to EUROTRADER-11
      if (this.User.info.country_code.toUpperCase() === 'US' && name === 'visa-mastercard') {
        PSPCountryAllowed = false
      }
      return PSPCurrencyAllowed && PSPCountryAllowed
    },
    requestWithdraw(url, data, successcb, failedcb) {
      this['logoLoader/set'](true)
      console.log('request data', data)

      service
        .post(url, data, 'requestwithdraw')
        .then(response => {
          if (!response.data.success) {
            // handle error messages here.
            if (response.data.messageID) {
              this['errorModal/set']({ active: true, text: this.$t(response.data.messageID).tTitle() })
            } else {
              this['errorModal/set']({ active: true, text: this.$t('error_request_failed').tTitle() })
            }
            this['logoLoader/set'](false)
            if (failedcb) {
              failedcb(response.data.error)
            }
            return
          }
          api.GetWallet()
          this.$router.push('/' + (this.Language || 'en') + '/finance/payment-history')
          this.$toasted.success(this.$t('withdrawal_request_success_message').tTitle())
          successcb(response)
          this['logoLoader/set'](false)
        })
        .catch(error => {
          this['logoLoader/set'](false)
          if (error.response) {
            if (error.response.data.meta) {
              let meta = error.response.data.meta
              let tkey = config.API.translationKeyName
              if (meta[tkey]) {
                this['errorModal/set']({ active: true, text: this.$t(meta[tkey]).tTitle() })
              }
            }
          }
          failedcb(error)
        })
    },
    getAPM(component, psp) {
      if (component == 'skrill' && psp != 'skrill') {
        return psp
      }

      return null
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>

<style lang="scss">
@import '../../assets/css/variables';

.form-container {
  border: solid $primary 3px;
}

span.title {
  vertical-align: top;
  font-weight: 500;
  font-size: 1.5rem;
  margin-top: 10px;
  text-align: left;
  display: block;
}
p.subtitle {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// Withdraw.vue?54cd142c